import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProfileComponent } from './profile/profile.component';
import { UserRoutingModule } from './user-routing.module';
import { ContactsComponent } from './contacts/contacts.component';
import { MaterialItemsModule } from '../shared/material-items.module';
import { SharedModule } from '../shared/shared.module';
import { ContactDeleteComponent } from './contacts/contact-delete/contact-delete.component';
import { ContactManageComponent } from './contacts/contact-manage/contact-manage.component';
import { PromptCheckDialogComponent } from './notification-preferences/prompt-check-dialog/prompt-check-dialog.component';
import { WcgDialogModule } from '@wcg/frontend-framework';
import { EffectsModule } from '@ngrx/effects';
import { DownloadExportsEffects } from '@data-access/downloads-exports';
import { StoreModule } from '@ngrx/store';
import {
  RESOURCE_REDUCER,
  ResourceEffects,
  ResourceService,
} from '@data-access/resource';
import { FullNamePipe } from '@shared/pipes/fullname.pipe';
import { StickyContentOffsetClassBasedDirective } from "@data-access/shared";

@NgModule({
  declarations: [
    ProfileComponent,
    ContactsComponent,
    ContactDeleteComponent,
    ContactManageComponent,
    PromptCheckDialogComponent,
  ],
  imports: [
    CommonModule,
    UserRoutingModule,
    SharedModule,
    MaterialItemsModule,
    WcgDialogModule,
    EffectsModule.forFeature([DownloadExportsEffects]),
    StoreModule.forFeature('resourcePage', RESOURCE_REDUCER),
    EffectsModule.forFeature([ResourceEffects]),
    FullNamePipe,
    StickyContentOffsetClassBasedDirective
  ],
  providers: [ResourceService],
})
export class UserModule {}
